import React from 'react'
import "../css/scroll-down.css"
import { motion, useScroll, useTransform } from "framer-motion"

const ScrollDown = ({ down }) => {

    // let y = useTransform(smoothY, [0, 600], [0, 300])


  return (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { duration: 0.7, delay: 3 } }} >
            <div className="scroll-down-container">
                <motion.div className="scroll-down-grid" style={{ y: down,
                        filter: "blur(0.5px)",
                        WebkitTransform: "translateZ(0)",
                        transform: "translateZ(0)",
                        WebkitBackfaceVisibility: "hidden",
                        backfaceVisibility: "hidden",
                        willChange: "filter" 
                 }}>
                    <div className='scroll-down'>SCROLL DOWN
                        <motion.div style={{ width: '100%', height: '1px', marginTop: '8px' , backgroundColor: '#fff000' }}></motion.div>
                    </div>
                </motion.div>
            </div>
        </motion.div>
    )
    }

export default ScrollDown